<template>
  <b-card title="Temperatures" body-class="temperatures-card">
    <table class="table">
      <tbody>
        <tr>
          <td>
            <strong>CPU</strong>
          </td>
          <td>
            {{this.isNumeric(temperature_cpu) ? temperature_cpu + ' °C' : '-'}}
          </td>
        </tr>
        <tr>
          <td>
            <strong>CPU PCB</strong>
          </td>
          <td>
            {{this.isNumeric(temperature_cpu_pcb) ? temperature_cpu_pcb + ' °C' : '-'}}
          </td>
        </tr>
        <tr>
          <td>
            <strong>FPGA</strong>
          </td>
          <td>
            {{this.isNumeric(temperature_fpga) ? temperature_fpga + ' °C' : '-'}}
          </td>
        </tr>
        <tr>
          <td>
            <strong>FPGA PCB</strong>
          </td>
          <td>
            {{this.isNumeric(temperature_fpga_pcb) ? temperature_fpga_pcb + ' °C' : '-'}}
          </td>
        </tr>
      </tbody>
    </table>
    <CardTimestampFooter v-bind:timestamp="timestamp"/>
  </b-card>
</template>
<script>
import CardTimestampFooter from '@/components/Device/CardTimestampFooter/CardTimestampFooter';

export default {
  name: 'TemperaturesCard',
  components: {CardTimestampFooter},
  props: ['temperature'],
  computed: {
    temperature_cpu(){
      return  this._props.temperature && this.isNumeric(this._props.temperature.cpu) ? this._props.temperature.cpu : '';
    },
    temperature_cpu_pcb(){
      return  this._props.temperature && this.isNumeric(this._props.temperature.cpu_pcb) ? this._props.temperature.cpu_pcb : '';
    },
    temperature_fpga(){
      return  this._props.temperature && this.isNumeric(this._props.temperature.fpga) ? this._props.temperature.fpga : '';
    },
    temperature_fpga_pcb(){
      return  this._props.temperature && this.isNumeric(this._props.temperature.fpga_pcb) ? this._props.temperature.fpga_pcb : '';
    },
    timestamp(){
      return this._props.temperature && this._props.temperature.timestamp ? this._props.temperature.timestamp : null;
    }
  }
}
</script>

<style src="./TemperaturesCard.scss" lang="scss" scoped/>
